import React, { type ReactNode } from "react";

import {
  type DefaultTheme,
  ThemeProvider,
  createGlobalStyle,
} from "styled-components";

import { THEME } from "theme";

interface GlobalStyleProps {
  borderBoxBoxSizing?: boolean;
}

const GlobalStyles = createGlobalStyle<GlobalStyleProps>(
  ({ theme: { body, components }, borderBoxBoxSizing }) => ({
    body: {
      background: body.background,
      color: body.color,
      fontFamily: body.fontFamily,
      fontWeight: body.fontWeight,
    },
    button: {
      background: components.button.background,
      color: components.button.color,
      "&:hover": {
        background: components.button.hoverBackground,
      },
      "&.disabled, &:disabled": {
        background: components.button.disabledBackground,
      },
      "&.text": {
        background: "unset",
        "&:hover": {
          background: "unset",
        },
      },
    },
    ...(borderBoxBoxSizing
      ? {
          "*": {
            boxSizing: "border-box",
          },
        }
      : {}),
  })
);

export interface AppThemeProviderProps extends GlobalStyleProps {
  children: ReactNode;
  theme?: DefaultTheme;
}

export const AppThemeProvider = ({
  children,
  theme = THEME,
  ...rest
}: AppThemeProviderProps) => {
  return (
    <ThemeProvider theme={theme}>
      {children}
      <GlobalStyles {...rest} />
    </ThemeProvider>
  );
};
